export const NUM_LOADING_ACCOUNT_ROWS = 3;

export const MAX_NEW_ACCOUNTS_WITHOUT_SELECTION_MODAL = 1;

export interface SocialAccountsListProps {
  controlledSelection?: SocialAccountsListControlledSelection;
  /** Replaces the default "open the connect-accounts modal" behaviour, for hosts that show that step inline instead. */
  onAddAccountClick?: VoidFunction;
}

interface SocialAccountsListControlledSelection {
  selectedAccountIds: number[];
  onSelectedAccountIdsChange: (selectedAccountIds: number[]) => void;
}
